import { createPageLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import { NOT_FOUND_LOAD_KEY } from '@confluence/browser-metrics/entry-points/metric-keys';
export const NOT_FOUND_PAGE_LOAD = createPageLoadMetric({
	key: NOT_FOUND_LOAD_KEY,
});
